import axios, { AxiosRequestConfig } from 'axios';
import Vue from 'vue';
import router from '../router';


//SALONWORLD
Vue.$urlAPI =  "https://adminapi.afsprakenboek.be/api/"; 
//Vue.$urlAPI =  "http://localhost:27887/api/"; 
Vue.$urlCDN =  "https://cdn.posworld.be/"; 


Vue.$tokenAPI = localStorage.getItem("usertoken");

const myHttpApi =  axios.create({
  baseURL: Vue.$urlAPI
});

myHttpApi.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers.common['MyToken'] = Vue.$tokenAPI;
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

myHttpApi.interceptors.response.use(function(response) {
  return response;
}, function(error) {

    if (error.response == undefined)
    {
       //console.log ("api error 1 :" + error);
       alert (error);
       router.push('/session/login');
    }
    else
    {
      if (error.response.status === 401) {
        router.push('/session/login');
      }
      else if (error.response.status === 406) {
        //Wordt verder in app opgevangen.. custom melding..
      }
      else  {
        //console.log ("api error 1 :" + error);
        alert (error);
      }
    }
    throw error;
  
});

export default myHttpApi;

